// import Vue from 'vue'
import consts from "@/consts"
import range from "lodash/range";
import {getApiProps, updateObjectByDiff} from "@/lib/lib";
// import {arraySplitIntoChunks} from "@/lib/lib";

const with_removed = String(process.env.VUE_APP_PACKAGE).includes('admin') ? {'force[with_removed]': 1} : {}
const changedField = 'updated_at';

const collator = new Intl.Collator();
const sortByName = function (a, b) {
    let cmp = collator.compare(a?.name_ || '', b?.name_ || '')
    if (cmp) {
        return cmp;
    }
    return a.id - b.id;
}

export default {
    state: {
        maintenanceFullLoad: false,
        maintenanceLiteLoad: false,
        maintenanceTypesOfWorks: {},
        maintenanceUnitsIds: [],
        maintenance: [],
    },
    actions: {
        fetchMaintenance/*all*/({dispatch, getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken) {
                    return reject(false)
                }
                dispatch('setLastCall', {name: 'fetchMaintenance', args, time: Date.now() / 1000})

                const params = getApiProps('maintenance', args)
                this.$api.maintenance.getAll({...params, ...with_removed})
                    .then((response) => {
                        if (response.status < 400 && !response.data.error) {
                            resolve(response.data)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchMaintenance', args, inprogress: false})
                    });
            })
        },
        fetchMaintenanceAllInit({/*dispatch,*/ commit, getters}) {
            return new Promise((resolve, reject) => {
                if (getters.isMaintenanceLiteLoad) {
                    return resolve(getters.getMaintenance.length)
                }
                this.$api.init.getMaintenance()
                    .then((response) => {
                        if (response.status < 400 && response.data?.maintenance) {

                            commit('setMaintenance', response.data.maintenance)
                            commit('setMaintenanceLiteLoad', true)

                            resolve(true)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                        //setTimeout(() => {
                        //    dispatch('fetchMaintenanceAllInit', {})
                        //}, 60 * 1000)
                    })
            })
        },
        fetchMaintenanceAllLite({dispatch, commit, getters}) {
            return new Promise((resolve, reject) => {
                if (getters.isMaintenanceLiteLoad) {
                    return resolve(getters.getMaintenance.length)
                }
                dispatch('fetchMaintenance', {lite: true})
                    .then((data) => {
                        commit('updateMaintenance', data)
                        commit('setMaintenanceLiteLoad', true)
                        resolve(data.length)
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                        setTimeout(() => {
                            dispatch('fetchMaintenanceAllLite', {})
                        }, 60 * 1000)
                    })
            })
        },
        fetchMaintenanceAllPages({dispatch, commit, getters}, args) {
            //dispatch('setLastCall', {name: 'fetchMaintenanceAll', args, time: Date.now() / 1000})
            dispatch('setLastCall', {name: 'fetchMaintenanceChanged', args, time: Date.now() / 1000})

            return new Promise((resolve, reject) => {
                    if (!getters.getApiToken) {
                        return reject(null)
                    }
                    if (!getters.getMaintenance.length) {
                        return resolve([])
                    }

                    let pageSize = consts.querySettings.maintenance.pageSize
                    let items = getters.getMaintenance.length
                    let pages = Math.ceil( items / pageSize)
                    if(pages > 8) {
                        pageSize = Math.ceil(items / consts.querySettings.maxPages)
                        pages = Math.ceil(items / pageSize)
                    }
                    let fetch = range(pages).map(i => {
                        let page = i + 1;
                        return dispatch('fetchMaintenance', {page, 'page-size': pageSize, ...args})
                            .then((data) => {
                                commit('updateMaintenance', data)
                            })
                            .catch(() => {
                                dispatch('fetchMaintenance', {page, 'page-size': pageSize, ...args})
                            })
                    });
                    resolve(fetch)
                })
                .then((fetch) => {
                    return Promise.all(fetch)
                        .finally(() => {
                            if (fetch.length) commit('setMaintenanceFullLoad', true)
                        })
                })
                .finally(() => {
                    //dispatch('setLastCall', {name: 'fetchMaintenanceAll', args, inprogress: false})
                    dispatch('setLastCall', {name: 'fetchMaintenanceChanged', args, inprogress: false})
                })
        },
        fetchMaintenanceChanged({dispatch, commit, getters}, args) {
            if (!getters.getApiToken || !getters.isMaintenanceFullLoad) {
                return Promise.resolve(null)
            }
            dispatch('setLastCall', {name: 'fetchMaintenanceChanged', args, time: Date.now() / 1000})

            args = {...consts.querySettings.filter, ...args}
            return dispatch('fetchMaintenance', args)
                .then((data) => {
                    commit('updateMaintenance', data)
                    return dispatch('fetchMaintenance', {fields: 'id', expand: ''})
                })
                .then((data) => {
                    commit('filterMaintenance', data)
                })
                .finally(() => {
                    dispatch('setLastCall', {name: 'fetchMaintenanceChanged', args, inprogress: false})
                });
        },

        fetchMaintenanceUnits/*all*/({dispatch, commit, getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken) {
                    return reject(false)
                }
                dispatch('setLastCall', {name: 'fetchMaintenanceUnits', args, time: Date.now() / 1000})

                const params = getApiProps('maintenance_units', args)
                this.$api.maintenance.getUnits({...params, ...with_removed})
                    .then((response) => {
                        if (response.status < 400 && !response.data.error) {
                            commit('updateMaintenanceUnits', response.data)
                            resolve(true)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchMaintenanceUnits', args, inprogress: false})
                    });
            })
        },
        fetchMaintenanceTypesOfWork/*all*/({dispatch, commit, getters}) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken) {
                    return reject(false)
                }
                dispatch('setLastCall', {name: 'fetchMaintenanceTypesOfWork', time: Date.now() / 1000})

                this.$api.maintenance.getTypesOfWork()
                    .then((response) => {
                        if (response.status < 400 && !response.data.error) {
                            commit('updateMaintenanceTypesOfWork', response.data)
                            resolve(true)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchMaintenanceTypesOfWork', inprogress: false})
                    });
            })
        },

        saveMaintenance({dispatch}, maintenance) {
            let fn = (maintenance.id) ? 'updateMaintenance' : 'createMaintenance'
            return dispatch(fn, maintenance);
        },
        createMaintenance({commit, dispatch}, maintenance) {
            return new Promise((resolve, reject) => {
                const params = getApiProps('maintenance')
                this.$api.maintenance.create(maintenance, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data.error) {
                            commit('updateMaintenance', response.data)
                            dispatch('fetchMaintenanceChanged')
                        }
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },
        updateMaintenance({commit, dispatch}, maintenance) {
            return new Promise((resolve, reject) => {
                const params = getApiProps('maintenance')
                this.$api.maintenance.update(maintenance.id, maintenance, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data.error) {
                            commit('updateMaintenance', response.data)
                            dispatch('fetchMaintenanceChanged')
                        }
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },
        deleteMaintenance({commit, dispatch}, id) {//remove
            return new Promise((resolve, reject) => {
                const params = getApiProps('maintenance')
                this.$api.maintenance.delete(id, {...params, ...with_removed})//remove
                    .then((response) => {
                        if (response.status < 400 && (!response.data || !response.data.error)) {
                            if (!response.data) commit('deleteMaintenance', id)
                            else commit('updateMaintenance', response.data)
                            dispatch('fetchMaintenanceChanged')
                        }
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },
    },
    mutations: {
        setMaintenanceFullLoad(state, FullLoad) {
            state.maintenanceFullLoad = state.maintenanceFullLoad || FullLoad
        },
        setMaintenanceLiteLoad(state, LitaLoad) {
            state.maintenanceLiteLoad = state.maintenanceLiteLoad || LitaLoad
        },

        setMaintenance(state, nMaintenance) {
            state.maintenance = nMaintenance
        },
        updateMaintenanceUnits(state, nUnits){
            state.maintenanceUnitsIds = nUnits
        },
        updateMaintenanceTypesOfWork(state, nTypesOfWork){
            state.maintenanceTypesOfWorks = nTypesOfWork
        },


        updateMaintenance(state, nMaintenance) {
            if (!state.maintenance.length) {
                nMaintenance = nMaintenance.map(u => {
                    if (u?.name) u.name_ = u.name.toLocaleLowerCase()
                    return u //Object.freeze(u)
                })
                nMaintenance.sort(sortByName)
                state.maintenance = nMaintenance
                // const chunks = arraySplitIntoChunks(nMaintenance)//.reverse();
                // const pushOnRenderTask = () => {
                //     if (chunks.length === 0) return;
                //     let chunk = chunks.pop();
                //     state.maintenance.push(...chunk);
                //     setTimeout(() => {
                //     requestAnimationFrame(pushOnRenderTask);
                //     }, 300)
                //     //this.$nextTick().then(() => pushOnRenderTask())
                // }
                // pushOnRenderTask();
                return true
            }

            nMaintenance.forEach(function (nMaintenance) {
                if (nMaintenance?.name) nMaintenance.name_ = nMaintenance.name.toLocaleLowerCase()
                let i = state.maintenance.findIndex(u => (u.id == nMaintenance.id))
                if (i < 0) {
                    state.maintenance.push(nMaintenance) //(Object.freeze(nMaintenance))
                } else
                if (!state.maintenanceFullLoad || state.maintenance[i][changedField] != nMaintenance[changedField]) {
                    updateObjectByDiff(state.maintenance[i], nMaintenance)
                    // delete nMaintenance.id
                    // nMaintenance = {...state.maintenance[i], ...nMaintenance}
                    // state.maintenance[i] = nMaintenance //Object.freeze(nMaintenance)
                }
            })

        },
        filterMaintenance(state, nMaintenance) {
            // let Ids = state.maintenance.map(u=> u.id)
            let nIds = nMaintenance.map(u => u.id)
            let removedIds = state.maintenance.filter(u => !nIds.includes(u.id)).map(u => u.id)
            removedIds.forEach(removedId => {
                let i = state.maintenance.findIndex(u => (u.id == removedId))
                if (i != -1) {
                    state.maintenance.splice(i, 1)
                }
            })
        },
        deleteMaintenance(state, id) {
            let i = state.maintenance.findIndex(u => (u.id == id))
            if (i != -1) {
                state.maintenance.splice(i, 1)
            }
        },

        clearMaintenance(state) {
            state.maintenance = []
            state.maintenanceFullLoad = false
        },
    },
    getters: {
        isMaintenanceFullLoad(state) {
            return state.maintenanceFullLoad
        },
        isMaintenanceLiteLoad(state) {
            return state.maintenanceLiteLoad
        },
        getMaintenance(state) {
            return state.maintenance
        },
        getMaintenanceByIds(state) {
            return state.maintenance.reduce((maintenanceByIds, maintenance) => {
                maintenanceByIds[maintenance.id] = maintenance
                return maintenanceByIds
            }, {})
        },
        getSortedMaintenanceIds(state) {
            let maintenance = state.maintenance
            maintenance.sort(sortByName)
            return maintenance.map(u => u.id)
        },
        getMaintenanceUnitsIds(state) {
            return state.maintenanceUnitsIds
        },
        getMaintenanceTypesOfWork(state) {
            return state.maintenanceTypesOfWorks
        }
    }
}
